import { render } from "./md2024-2.vue?vue&type=template&id=0dce042c"
import script from "./md2024-2.vue?vue&type=script&lang=js"
export * from "./md2024-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__